<link
  rel="stylesheet"
  href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
  integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
  crossorigin="anonymous"
/>

<div class="container about-us-persona">
    <div class="row d-flex justify-content-center">
      <div class="d-flex justify-content-center">
        <div class="col-sm">
            <div class="card-body project-body">
            <h3 class="card-title card-title-about">About the project</h3><hr>
      <p class="card-text">Päikese Pizza app was created as a final project for Software Development Academy's Javascript course using:</p>
      <h6 class="card-text">Angular, Visual Studio Code & Bootstrap</h6>
      <h6 class="card-text-about">No actual pizzas, sorry!</h6>
      <hr>
    </div>
        </div>
      </div>
<div class="d-flex justify-content-center about-us-persona">
<div class="col-sm">
  <div class=" card-about" style="width: 18rem;">
    <h2 class="card-title">Meet Anthony</h2>
      <img src="/assets/img/anthony.jpg" class="card-img-top" alt="Anthony Chapman">
      <div class="card-body">
        <p class="card-text">Anthony Chapman is a Junior Web Developer. He spends most of his free time studying web development, 
          but he also enjoys cycling, walking in the forest, games (video & table), and, of course, pizza. He is American by birth, but Estonian by choice. </p>
        <!-- Section: Social media -->
        <section class="mb-4">
          <!-- Linkedin -->
          <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="https://www.linkedin.com/in/manthonychapman/" target="_blank"
            role="button"
            data-mdb-ripple-color="dark">
            <i class="fab fa-linkedin"></i>
          </a>
          <!-- Gitlab -->
          <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="https://gitlab.com/Anthony.Chapman" target="_blank"
            role="button"
            data-mdb-ripple-color="dark">
            <i class="fab fa-gitlab"></i>
          </a>
        <!-- Email -->
        <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="mailto:MicAntCha@gmail.com"
            role="button"
            data-mdb-ripple-color="dark">
            <i class="fas fa-envelope"></i>
          </a>
          <!-- Facebook -->
          <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="https://www.facebook.com/MicAntCha/" target="_blank"
            role="button"
            data-mdb-ripple-color="dark">
            <i class="fab fa-facebook-f"></i>
          </a>
        </section>
      </div>
    </div>
</div>
<div class="col-sm">
  <div class=" card-about" style="width: 18rem;">
    <h2 class="card-title">Meet Mariann</h2>
        <img src="/assets/img/mariann.jpg" class="card-img-top" alt="Mariann Rea-Peterson">
        <div class="card-body">
          <p class="card-text">Mariann Rea-Peterson is a graphic designer, photographer, Wordpress Developer and Junior Front-End Developer. She is passionate about design and loves to be around animals and in the nature. In her free time she enjoys gardening.</p>
          <div class="card-text">
        <!-- Section: Social media -->
        <section class="mb-4">
          <!-- Linkedin -->
          <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="www.linkedin.com/in/mariann-rea-peterson" target="_blank"
            role="button"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-linkedin"></i
          ></a>
          <!-- Gitlab -->
          <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="https://gitlab.com/littlefox22/" target="_blank"
            role="button"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-gitlab"></i
          ></a>
        <!-- Email -->
        <a
            class="btn btn-link btn-floating btn-lg text-dark m-1"
            href="mailto:photo@mariannrea.com"
            role="button"
            data-mdb-ripple-color="dark"
            >
        <i class="fas fa-envelope"></i
            ></a>
                      <!-- Facebook -->
          <a
          class="btn btn-link btn-floating btn-lg text-dark m-1"
          href="https://www.facebook.com/LittleFoxPhotos/" target="_blank"
          role="button"
          data-mdb-ripple-color="dark"
          ><i class="fab fa-facebook-f"></i
        ></a>
        </section>
        <!-- Section: Social media -->
    </div>
        </div>
      </div>
</div>
</div>
    </div>
</div>